import { httpRequest } from "../../utils/httpRequest";

export async function listItems(token, { q = "", kind = "", status = "published" } = {}) {
  const qs = new URLSearchParams();
  if (q) qs.set("q", q);
  if (kind) qs.set("kind", kind);
  if (status) qs.set("status", status);

  return httpRequest("GET", `/item?${qs.toString()}`, {}, { "x-access-token": token });
}
